export enum LoadingActionTypes {
  SHOW = 'Loading.SHOW',
  HIDE = 'Loading.HIDE',
  RESET = 'Loading.RESET',
}
